export const exportKnmTypeEventFormNamesMap: Record<string, string> = {
  ERKNM: 'КНМ',
  PM: 'ПМ',
  ERP: 'КНМ',
};
